export function openNewTab(url: string, inBackgroundPreferred = false) {
  const isOpenInBackgroundExtensionEnabled = document.body.dataset.openInBackgroundExtension === "true";
  if (inBackgroundPreferred && isOpenInBackgroundExtensionEnabled) {
    window.postMessage({ type: "OPEN_IN_BACKGROUND", url });
  } else {
    window.open(url, "_blank");
  }
}
